import * as React from 'react'
import { WidgetWrapper, useEffectWithPolling } from 'uxp/components'
import { IUIPropertyDefinitionMap, IWidgetTemplateInstanceProps, IWidgetTemplateProps, registerCardTemplate } from '../../../common/common'
import { generateIconProp } from '../../../common/icon-selector/IconEditor'
import { SelectableItem, selectUIProps } from '../../../common/SelectableItem'
import { ContainerProperty, extractContainerProperties } from '../../../common/ui-props/ContainerProperty'
import { DataSourceProperty } from '../../../common/ui-props/DataSourceProperty'
import { Statistics } from './StatisticsCardWidgetTemplateProperty'
import { TextProperty } from '../../../common/ui-props/TextProperty'
import { containsExpressions, hasValue, replaceWithData } from '../../../../util'
import { IContextData, appendDataToContextBySource, useInitialContextData } from '../../../../hooks/useContextData'
import './styles.scss'
import { executeAndBind, IDataSourceBinding, processInitialSource } from '../../../common/data-source-picker/datasource'
import { ActionProperty } from '../../../common/ui-props/ActionProperty'
import { ClickProperty } from '../../../common/ui-props/ClickProperty'
import ActionRenderComponent from '../../../common/components/ActionRenderComponent'
import { IAction } from '../../../common/action-editor/ActionEditor'

const XPR: React.ForwardRefExoticComponent<React.RefAttributes<IWidgetTemplateInstanceProps> & IWidgetTemplateProps> = React.forwardRef((props, ref) => {
    let uiProps = props?.uiProps || {};
    const inDesignMode = (props.designer && props?.designer?.mode && (props.designer.mode == 'preview' || props.designer.mode == 'thumbnail'))

    const [loading, setLoading] = React.useState(false)
    const [contextData, setContextData] = React.useState<IContextData>({})
    const [initialSource, setIntitialSource] = React.useState(props.initialSource);
    const [actionData, setActionData] = React.useState<{ action: IAction, contextData: IContextData }>({ action: null, contextData: {} })
    const [widgetData, setWidgetData] = React.useState(null)

    const { isLoading, initialContextData } = useInitialContextData(props, [props?.uiProps?.source])

    React.useEffect(() => {
        setLoading(isLoading)
        setContextData(prev => ({ ...prev, ...initialContextData }))
    }, [isLoading, initialContextData])

    React.useEffect(() => {
        processInitialSource(props.designer, props.uxpContext, props.uiProps, initialSource, 'dictionary')
            .then(res => {
                if (res) props.designer?.setUIProps(res)
            })
            .catch(e => {
                console.log('exception ', e);

            })
    }, [initialSource]);


    const XPRProps: IUIPropertyDefinitionMap = {
        "container": ContainerProperty({
            background: {
                color: "#ffffff",
                image: {
                    image: "",
                    position: "",
                    size: "",
                },
            }
        }),
        'source': DataSourceProperty('Source', uiProps.source, uiProps.datasources, props.uxpContext, props.designer, 'dictionary'),

        'title': TextProperty({ text: 'Energy Consumption', color: '#000000', size: '18px' }, 'Title'),
        'subTitle': TextProperty({ text: 'Total energy consumed from May 1- May 31', color: '#000000', size: '12px' }, 'Sub Title'),
        'subTitle2': TextProperty({ text: 'Total Building', color: '#000000', size: '12px' }, 'Value Label'),
        'units': TextProperty({ text: 'KWH', color: '#000000', size: '18px' }, 'Units',),
        'value': TextProperty({ color: '#000000', size: '48px' }, ' '),
        'valueField': Statistics("Main Text", uiProps.valueField),
        'onClick': ClickProperty("On Click", { type: 'open-url', redirectUrl: { url: 'about:blank', target: '_blank' } }),
        'defaultValue': TextProperty({ 'text': '0' })
    }

    let { text: title = 'Energy Consumption', color: titleColor = '#000000', size: titleFont = '18px' } = uiProps?.title || {};
    let { text: subTitle = 'Total energy consumed from May 1- May 31', color: subTitleColor = '#000000', size: subTitleFont = '12' } = uiProps?.subTitle || {};
    let { text: subTitle2 = 'Total Building', color: subTitleColor2 = `#000000`, size: subTitleFont2 = '12px' } = uiProps?.subTitle2 || {};
    let { color: maincolor = `#000000`, size: valueFont = '48px', text = '0' } = uiProps?.value || {};
    let { text: units = 'KWH', color: unitsColor = `#000000`, size: unitsFont = '18px' } = uiProps?.units || {};

    let { styles: containerStyles } = extractContainerProperties(uiProps.container, contextData);

    const updatedContextData = appendDataToContextBySource(contextData, uiProps?.source, widgetData)

    title = replaceWithData(title,updatedContextData)
    subTitle = replaceWithData(subTitle,updatedContextData)
    subTitle2 = replaceWithData(subTitle2, updatedContextData)
    units = replaceWithData(units, updatedContextData)

    // Hack to prevent showing expressions
    // replace the value and check if it still contains expressions, if so check for default value else show 0
    // this needs to be handle using pill input - nned to develop this 
    const parsedMainValue = inDesignMode ? 25 : replaceWithData(uiProps.valueField, updatedContextData)
    const finalValue = (hasValue(parsedMainValue) && containsExpressions(parsedMainValue)) ? (hasValue(uiProps?.defaultValue) ? uiProps.defaultValue : 0) : parsedMainValue
    console.log('parsed_______', parsedMainValue, finalValue)

    const onClick = uiProps.onClick || null

    useEffectWithPolling(props.uxpContext, '', 60000, async () => {

        const _source: IDataSourceBinding = uiProps?.source

        if (!inDesignMode && !!_source) {
            executeAndBind(props.uxpContext, uiProps.source, uiProps.datasources, {}, contextData)
                .then((d: any) => {
                    setWidgetData(d)
                })
                .catch(e => {
                    console.log('error', e)
                })
        }

    }, [inDesignMode, contextData, uiProps]);


    function handleClick(e: React.MouseEvent) {
        e.preventDefault()
        if (props.designer && (props.designer.mode == 'preview' || props.designer.mode == 'thumbnail')) {
            return
        }
        setActionData({ action: onClick, contextData: contextData })
    }

    return (
        <WidgetWrapper className='statistics-card-widget-template wd-widget-wrapper'>
            <div className="bg" style={containerStyles} onClick={handleClick}>
                <SelectableItem
                    designer={props.designer}
                    props={selectUIProps(uiProps, XPRProps, 'container', 'title', 'subTitle', 'source', 'valueField', 'value', 'units', 'subTitle2', 'onClick')}
                    contextData={contextData}
                >
                    <div className='container'>
                        <div className='title-bar-wrapper'>
                            <div className="uxp-widget-title-bar uxp-drag-handler">
                                <div className='title-section-wrapper'>
                                    <div className="title-section">
                                        <span className="txt" style={{ color: titleColor, fontSize: `${titleFont}` }}>{title}</span>
                                    </div>
                                </div>
                                <div className='sub-title' style={{ color: subTitleColor, fontSize: `${subTitleFont}` }}>{subTitle}</div>
                            </div>
                        </div>

                        <div className="data-area-container-wrapper">
                            <div className="data-area-container">
                                <div className='data-area'>
                                    <div className='data'>
                                        <span className='value' style={{ color: maincolor, fontSize: `${valueFont}` }}>{finalValue}</span>
                                        <span className='unit' style={{ color: unitsColor, fontSize: `${unitsFont}` }}>{units}</span>
                                    </div>
                                    <div>
                                        <span className='sub-title2' style={{ color: subTitleColor2, fontSize: `${subTitleFont2}px` }}>{subTitle2}</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </SelectableItem>
            </div>


            <ActionRenderComponent
                designer={props.designer}
                uxpContext={props.uxpContext}
                {...actionData}
                onClose={() => setActionData({ action: null, contextData: {} })}
                onReloadWidget={() => { }}
            />

        </WidgetWrapper>
    )
})

registerCardTemplate({
    id: 'statistics-card',
    name: 'Statistics Card',
    description: 'This widget can be used to show statistics info ',
    template: XPR,
    icon: generateIconProp('boxes'),
    complexity: 'easy',
    expectedSchema: 'dictionary'
});
